export default {
  DASHBOARD: '/dashboard',
  DEFAULT: '/',
  GLOBAL: '/global',
  LOGIN: '/login',
  FUNNEL: '/funnel',
  AUDIENCE: '/audience',
  ACTIVATION: '/activation',
  PML: '/pml',
  CAMPAIGN: '/campaign',
  LLM: '/llm',
  CONTENTS: '/contents'
};
